import styled from "styled-components";

const NavbarBrand = styled.img`
  max-height: 32px;
  max-width: 200px;
  margin: 8px 16px;
  line-height: 32px;
  color: white;
  font-family: "Roboto Mono", monospace;
`;

export default NavbarBrand;



// WEBPACK FOOTER //
// ./src/UI/Navbar/NavbarBrand.js